import { toast } from "react-toastify";
import { getSizeFieldsForCategory } from "../../../dashboard/merchant/utils/categoryFormConfig";
import { getProductSizes, getProductStockAvailable } from "./productSizes";

export const notifyAddToCartResult = (result) => {
  if (result?.needsSize) return false;
  if (result?.success) {
    toast.success("Added to cart");
    return true;
  }
  toast.error(result?.message || "Could not add to cart.");
  return false;
};

export const addProductToCart = (addItemToCart, product, quantity = 1) => {
  const sizeFields = getSizeFieldsForCategory(product.category);
  const sizes = getProductSizes(product, sizeFields);

  if (sizes.length > 0 && !product.selectedSize) {
    toast.error("Please select a size");
    return { success: false, message: "Please select a size" };
  }

  const stockAvailable =
    product.stockAvailable != null
      ? product.stockAvailable
      : getProductStockAvailable(product, product.selectedSize || null, sizeFields);

  const result = addItemToCart(
    { ...product, stockAvailable },
    quantity
  );
  notifyAddToCartResult(result);
  return result;
};
